import { render, staticRenderFns } from "./supplier-products-table.vue?vue&type=template&id=2f0ba3a8&"
import script from "./supplier-products-table.vue?vue&type=script&lang=js&"
export * from "./supplier-products-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports